export default "https://cdn-static.gokick.com/assets/be369b33e14920b1856d71de34d484ec78759d8a/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";